import type { TelegramWebApp } from './telegram';

export type ShareResult = 'shared' | 'declined' | 'unsupported' | 'timeout';

/** True inside a Telegram client new enough for the native "Share phone number" sheet. */
export function canSharePhone(tg: TelegramWebApp | null): boolean {
  return Boolean(tg?.requestContact && (tg.isVersionAtLeast?.('6.9') ?? true));
}

/**
 * Shows Telegram's "Share phone number" sheet. Telegram delivers the contact to our bot as a
 * message (that is what proves the number), so after the player agrees this polls `arrived` until
 * the server has it, for up to ~15 s.
 */
export function sharePhone(tg: TelegramWebApp | null, arrived: () => Promise<boolean>): Promise<ShareResult> {
  if (!tg || !canSharePhone(tg)) return Promise.resolve('unsupported');
  return new Promise((resolve) => {
    tg.requestContact!(async (shared) => {
      if (!shared) return resolve('declined');
      for (let i = 0; i < 20; i++) {
        if (await arrived().catch(() => false)) return resolve('shared');
        await new Promise((r) => setTimeout(r, 750));
      }
      resolve('timeout');
    });
  });
}
